// extracted by mini-css-extract-plugin
module.exports = {"text-row":"text-row_text-row__nSYpV"};